import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _ExportProductionPlan, _InterestMora, _ProductionPlan } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { BankAccountSelect } from "../../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import usePaginator from "../../../../theme/Component/usePaginator";
import { AccountantYear } from "./AccountantYear";
import { MonthEditorbyconst } from "../../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { SelectProductEditor } from "../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { SelectorUmeasurement } from "../../../../bpm/config/Componentes/SelectorUmeasurement";
import { SelectProject } from "../../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { PlanItemCatalog } from "./PlanItemCatalog";



export const ProductionPlan = () => {

    const ProductionPlan = useDataBean(_ProductionPlan);
    const exportProduction = useDataBean(_ExportProductionPlan);
    const single = Singleton.getInstance();
    const [formatoticket, setFormatoticket] = useState<any>([]);
    const [lista, setLista] = useState<any>([]);
    const [modalresp, setModalresp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldesc, setModaldesc] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalprom, setModalprom] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalhistorial, setModalhistorial] = useState<any>({ name: 'Historial', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcerti, setModalcerti] = useState<any>({ name: 'Certificaciones', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalref, setModalref] = useState<any>({ name: 'Referencias', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldoc, setModaldoc] = useState<any>({ name: 'Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const [Months, setMonths] = useState<any>(null)
    const [product, setProduct] = useState<number>(null);
    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [paginador.page])


    const getLista = () => {

        ProductionPlan.instance.getProductionPlanCatalog(product, Year, Months, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }

            }
        )

    }



    const create = () => {
        ProductionPlan.setBean({

        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        if (!ProductionPlan.bean.Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }
        if (!ProductionPlan.bean.IDProduct) {
            toast.warning("Debe seleccionar un Producto.");
            return;
        }
        //console.log(Project.bean);
        ProductionPlan.instance.updateProductionPlan(ProductionPlan.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const exportProductionPlan = () => {
        if (!exportProduction.bean.Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }
        exportProduction.instance.exportProductionPlan(exportProduction.bean.Year).then(
            (resp: any) => {


                setModaldesc({ ...modaldesc, "view": false });
                toast.success('Reporte Generado')
                setFormatoticket(resp[0]);
                setModalresp({ ...modalresp, "view": true })
                console.log(resp)
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        ProductionPlan.deleteItemVoid(ProductionPlan.bean.IDProductionPlan).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const ver = () => {
        setModaldesc({ ...modaldesc, "view": true });

    }


    const head = [
        { title: 'ID', property: 'IDProductionPlan', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },



    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Consultar Programación', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalprom({ ...modalprom, "view": true }) } },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Plan Maestro de Producción">
            <div className="row">
                <div className="col-md-4">
                    <SelectProductEditor label="Producto Final" value={product} onChange={(e) => { setProduct(e.IDProduct) }} />
                </div>
                <div className="col-md-4">
                    <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthEditorbyconst idSelector={Months} onChange={(e) => { setMonths(e) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-add-circle-line" clase="btn btn-outline-primary btn-border" eventClick={ver}>
                        Descargar Presupuesto de Producción
                    </BasicButton>
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={ProductionPlan.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <AccountantYear idSelector={ProductionPlan.bean.Year} onChange={(e) => { ProductionPlan.setBean({ ...ProductionPlan.bean, "Year": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <SelectProductEditor value={ProductionPlan.bean.IDProduct} label="Producto Final" onChange={(e) => { ProductionPlan.setBean({ ...ProductionPlan.bean, "IDProduct": e.IDProduct }) }} />
                                </div>

                                <div className="col-md-6">
                                    <SelectorUmeasurement idSelector={ProductionPlan.bean.IDMeasurementUnit || ''} onChange={(e) => { ProductionPlan.setBean({ ...ProductionPlan.bean, "IDMeasurementUnit": e }) }} titulo="Unidad de Medida" />
                                </div>
                                <div className="col-md-6">
                                    <SelectProject idSelector={ProductionPlan.bean.IDProject} onChange={(e) => { ProductionPlan.setBean({ ...ProductionPlan.bean, "IDProject": e }) }} label="Proyecto" />
                                </div>
                                <div className="col-md-12">
                                    <label >Observaciones</label>
                                    <textarea name='Observations' className="form-control" value={ProductionPlan.bean.Observations} onChange={ProductionPlan.handleChange} ></textarea>
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modaldesc} updateModal={setModaldesc} eventModal={exportProductionPlan}>
                        <>
                            <div className="row">
                                <div className="col-md-12">
                                    <AccountantYear idSelector={exportProduction.bean.Year} onChange={(e) => { exportProduction.setBean({ ...exportProduction.bean, "Year": e }) }} />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <Modal modal={modalprom} updateModal={setModalprom}>
                        <>
                            <div className="row">
                                <PlanItemCatalog idProductionPlan={ProductionPlan.bean.IDProductionPlan} productionPlanDate={ProductionPlan.bean.ProductionPlanDate} />
                            </div>
                        </>
                    </Modal>
                    <div className="col-md-12">
                        <Modal modal={modalresp} updateModal={setModalresp}>
                            <>
                                <div className="row">
                                    {/* <div className="col-md-6">
                                <BasicButton eventClick={exportProductionOrdersbyaccion} icon="ri-inbox-archive-line" children={"Exportar a Excel Ordenes de Producción"} />
                            </div> */}

                                    <div className="col-md-12">
                                        {formatoticket?.DataBeanProperties?.URLLink && (
                                            // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                            <div className="row">
                                                <div className="col-md-12 mt-3">
                                                    <label>Descarga en el Siguiente Link:*</label>
                                                </div>
                                                <div className="col-md-6 mt-3">
                                                    <a href={formatoticket.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                        <strong>📄 {formatoticket.DataBeanProperties.Filename}</strong>
                                                    </a>
                                                </div>
                                            </div>

                                        )}
                                    </div>
                                </div>

                            </>
                        </Modal>
                    </div>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}